// extracted by mini-css-extract-plugin
export default {"primary_color":"#003066","secondary_color":"#0078ff","tertiary_color":"#e9eef4","white_color":"#fff","black_color":"#000","grey_color":"#e9eef4"};